import { render } from "./Package-add.vue?vue&type=template&id=39657933&scoped=true"
import script from "./Package-add.vue?vue&type=script&lang=js"
export * from "./Package-add.vue?vue&type=script&lang=js"

import "./Package-add.vue?vue&type=style&index=0&id=39657933&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39657933"]])

export default __exports__